import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"
import { FileGet } from "../../../../../../../_ovlclient/src/global/globalapi"
import { D, T } from "../../../../../../../_ovlclient/src/global/globals"

import type { DownloadPopup } from "../../../parts/downloadpopup/downloadpopup"
import { FileType } from "../../../parts/filelist/filelist"

export type DPInvoiceOverviewState = {
  activeFilePopup: string
}

export class CompDPInvoiceOverview extends SYSBaseElement {
  handleFile(e: Event, fileName: string, fileType: FileType, docNum: string) {
    e.preventDefault()
    FileGet({
      ext: "",
      id1: fileName,
      cat: fileType,
      id2: docNum,
    })
  }

  async getUI() {
    // const handlePDFPopup = (e) => {
    //   if (!e.target.disabled) {
    //     e.stopPropagation()
    //     let id = e.target.getAttribute("aria-controls").replace("pQqQR219", "")
    //     if (
    //       this.state.app.screens.DATInvoice.invoiceOverview.activeFilePopup ===
    //       id
    //     ) {
    //       id = ""
    //     }
    //     this.actions.app.global.actions.TogglePDFPopup({
    //       key: id,
    //       obj: this.state.app.screens.DATInvoice.invoiceOverview,
    //     })
    //   }
    // }

    const handleRemoveAllPDFPopup = (e) => {
      this.actions.app.global.actions.TogglePDFPopup({
        key: "",
        obj: this.state.app.screens.DATInvoice.invoiceOverview,
      })
    }

    let detailCount = Object.keys(
      this.state.app.screens.DATInvoice.dpInvoiceDetail.dpInvoices
    ).length
    if (detailCount === 0) {
      return null
    }

    return html`
      <div  class="app-document-overview ovl-smart-padding-symmetrical ovl-smart-screen-margins" @click=${handleRemoveAllPDFPopup}>
            <div class="fd-layout-panel">
            <div class="fd-layout-panel__header">
              <div class="fd-layout-panel__head">
                <h3
                  class="sap-icon--sales-order sap-icon--xl"
                >
                  ${T("DATDocumentDataDPInvoices")}
                </h3>
                <h4>
                  ${T("DATDocumentDataDPInvoiceListTitle", [
                    detailCount.toString(),
                  ])}
                </h4>
              </div>
            </div>

        

              <div class="fd-layout-panel__body">
                <table class="fd-table">
                  <thead class="fd-table__header">
                    <tr class="fd-table__row">
                    <th class="fd-table__cell" width="2%" scope="col">${T(
                      "GENPDF"
                    )}</th>
                      <th class="fd-table__cell" width="20%" scope="col">${T(
                        "GENNumber"
                      )}</th>
                      <th class="fd-table__cell" width="53%" scope="col">${T(
                        "GENCommission"
                      )}</th>
                      <th class="fd-table__cell" width="25%" scope="col">${T(
                        "GENDate"
                      )}</th>
                      <!-- <th class="fd-table__cell" width="10%" scope="col" style="text-align: right;">
                        ${T("DATDocumentDataInvoicePaidRate")}
                      </th> -->
                    </tr>
                  </thead>
                  <tbody class="fd-table__body">
                    ${Object.keys(
                      this.state.app.screens.DATInvoice.dpInvoiceDetail
                        .dpInvoices
                    )
                      .sort((a, b) => parseInt(b) - parseInt(a))
                      .map((k) => {
                        let o =
                          this.state.app.screens.DATInvoice.dpInvoiceDetail
                            .dpInvoices[k]
                        let bgColor = "fd-has-background-color-background-5"
                        let dueDate = new Date(o.docDueDate)
                        //add 7 days because it needs some time to get the payments into sap
                        dueDate.setDate(dueDate.getDate() + 1 + 7)
                        if (o.paidRate > 99 || dueDate.getTime() > Date.now()) {
                          bgColor = "fd-has-background-color-background-6"
                        }

                        let downloadPopup = html`<comp-downloadpopup
                          .props=${() => {
                            return <DownloadPopup>{
                              activePopupKey:
                                this.state.app.screens.DATInvoice
                                  .invoiceOverview.activeFilePopup,
                              docNum: k,
                              documentDetailsState:
                                this.state.app.screens.DATInvoice
                                  .dpInvoiceDetail.dpInvoices,
                              documentScreensState:
                                this.state.app.screens.DATInvoice
                                  .invoiceOverview,

                              popupId: "ovlpdfpop2",
                              type: "DPInvoice",
                              onOpen: async () => {
                                await this.actions.app.screens.DATInvoice.actions.FetchDPInvoiceDetail(
                                  k
                                )
                              },
                            }
                          }}
                        >
                        </comp-downloadpopup>`

                        return html`
                          <tr class="fd-table__row ${bgColor}">
                            <td class="fd-table__cell">${downloadPopup}</td>

                            <td class="fd-table__cell">${k}</td>
                            <td class="fd-table__cell">${o.refNum}</td>
                            <td class="fd-table__cell" style="width:28%;">
                              ${D(o.docDate)}
                            </td>
                            <!-- <td style="text-align: right;">
                              ${Math.round(o.paidRate)}
                            </td> -->
                          </tr>
                        `
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }
}
